import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback } from 'react';
import { NodeSelection } from '@atlaskit/editor-prosemirror/state';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { hideDatasourceModal } from '../../pm-plugins/actions';
import { insertDatasource, updateCardViaDatasource } from '../../pm-plugins/doc';
import { useFetchDatasourceInfo } from '../useFetchDatasourceInfo';
export var DatasourceModal = function DatasourceModal(_ref) {
  var _existingNode$attrs, _existingNode$attrs2;
  var view = _ref.view,
    cardContext = _ref.cardContext,
    defaultDatasourceId = _ref.datasourceId,
    Component = _ref.componentType;
  var state = view.state;
  var existingNode = getExistingNode(state);
  var dispatch = view.dispatch,
    transaction = view.state.tr;
  var onClose = useCallback(function () {
    dispatch(hideDatasourceModal(transaction));
  }, [dispatch, transaction]);
  var updateAdf = useUpdateAdf(view, existingNode);
  var isRegularCardNode = !!(existingNode && !(existingNode !== null && existingNode !== void 0 && (_existingNode$attrs = existingNode.attrs) !== null && _existingNode$attrs !== void 0 && _existingNode$attrs.datasource));
  var _ref2 = (existingNode === null || existingNode === void 0 || (_existingNode$attrs2 = existingNode.attrs) === null || _existingNode$attrs2 === void 0 ? void 0 : _existingNode$attrs2.datasource) || {},
    _ref2$id = _ref2.id,
    datasourceId = _ref2$id === void 0 ? defaultDatasourceId : _ref2$id,
    _ref2$views = _ref2.views,
    views = _ref2$views === void 0 ? [] : _ref2$views,
    nodeParameters = _ref2.parameters;
  var _resolveColumnsConfig = resolveColumnsConfig(views),
    visibleColumnKeys = _resolveColumnsConfig.visibleColumnKeys,
    wrappedColumnKeys = _resolveColumnsConfig.wrappedColumnKeys,
    columnCustomSizes = _resolveColumnsConfig.columnCustomSizes;
  var _useFetchDatasourceIn = useFetchDatasourceInfo({
      isRegularCardNode: isRegularCardNode,
      url: existingNode === null || existingNode === void 0 ? void 0 : existingNode.attrs.url,
      cardContext: cardContext,
      nodeParameters: nodeParameters
    }),
    parameters = _useFetchDatasourceIn.parameters,
    ready = _useFetchDatasourceIn.ready;
  if (!ready) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Component, {
    datasourceId: datasourceId,
    viewMode: isRegularCardNode ? 'inline' : 'table' // Want non-datasource cards to open in inline view since they are in table view
    ,
    parameters: parameters,
    url: existingNode === null || existingNode === void 0 ? void 0 : existingNode.attrs.url,
    visibleColumnKeys: visibleColumnKeys,
    columnCustomSizes: columnCustomSizes,
    wrappedColumnKeys: wrappedColumnKeys,
    onCancel: onClose,
    onInsert: updateAdf
  });
};
var useUpdateAdf = function useUpdateAdf(view, existingNode) {
  return useCallback(function (newAdf, analyticEvent) {
    if (analyticEvent) {
      analyticEvent.update(function (payload) {
        return _objectSpread(_objectSpread({}, payload), {}, {
          attributes: _objectSpread(_objectSpread({}, payload.attributes), {}, {
            inputMethod: 'datasource_config'
          })
        });
      });
    }
    if (existingNode) {
      updateCardViaDatasource({
        state: view.state,
        node: existingNode,
        newAdf: newAdf,
        view: view,
        sourceEvent: analyticEvent
      });
    } else {
      insertDatasource(view.state, newAdf, view, analyticEvent);
    }
  }, [existingNode, view]);
};
var getExistingNode = function getExistingNode(state) {
  var selection = state.selection;
  var existingNode;
  if (getBooleanFF('platform.linking-platform.enable-datasource-appearance-toolbar')) {
    // Check if the selection contains a link mark
    var isLinkMark = state.doc.resolve(selection.from).marks().some(function (mark) {
      return mark.type === state.schema.marks.link;
    });

    // When selection is a TextNode and a link Mark is present return that node
    if (selection instanceof NodeSelection) {
      existingNode = selection.node;
    } else if (isLinkMark) {
      var _state$doc$nodeAt;
      existingNode = (_state$doc$nodeAt = state.doc.nodeAt(selection.from)) !== null && _state$doc$nodeAt !== void 0 ? _state$doc$nodeAt : undefined;
    }
  } else {
    existingNode = selection instanceof NodeSelection ? selection.node : undefined;
  }
  return existingNode;
};
var resolveColumnsConfig = function resolveColumnsConfig(views) {
  var _tableView$properties;
  var _views = _slicedToArray(views, 1),
    tableView = _views[0];
  var visibleColumnKeys = [];
  var wrappedColumnKeys = [];
  var columnCustomSizes = {};
  var columns = tableView === null || tableView === void 0 || (_tableView$properties = tableView.properties) === null || _tableView$properties === void 0 ? void 0 : _tableView$properties.columns;
  if (columns) {
    var _iterator = _createForOfIteratorHelper(columns),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _step.value,
          _key = _step$value.key,
          width = _step$value.width,
          isWrapped = _step$value.isWrapped;
        visibleColumnKeys.push(_key);
        if (width) {
          columnCustomSizes[_key] = width;
        }
        if (isWrapped) {
          wrappedColumnKeys.push(_key);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return {
    visibleColumnKeys: visibleColumnKeys,
    wrappedColumnKeys: wrappedColumnKeys,
    columnCustomSizes: columnCustomSizes
  };
};